<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import Grid from '../Shared/Grid'
import ManagerAffiliateModal from '../User/ManagerAffiliateModal'
import { notify } from 'src/plugins/notify'

const moment = require('moment')

export default {
  name: 'UserManagers',
  components: {
    Grid,
    ManagerAffiliateModal
  },
  data () {
    return {
      moment: moment,
      module: this.$route.meta.module,
      columnOptions: [
        { field: row => `${row.MANAGER.USER.USER_FIRST_NAME} ${row.MANAGER.USER.USER_LAST_NAME}`, sortColumn: 'MANAGER_ID', name: 'MANAGER', label: 'Manager', sortable: true, type: 'string' },
        { field: 'DATE_CREATED', name: 'DATE_CREATED', label: 'Date Associated', sortable: true, type: 'string' },
        { field: r=>r.MANAGER.ACTIVE_IND, name: 'ACTIVE_IND', label: 'Manager Status', sortable: true, type: 'string' },

      ],
      removeDialogOptions: {
        title: `Remove Manager(s)?`,
        message: "This action cannot be undone.",
        noBackdropDismiss: true,
        ok: {
            label: "Remove",
            color: 'positive'
        },
        cancel: {
            label: 'Cancel',
            color: 'grey'
        }
      }
    }
  },
  computed: {
    ...mapState('users', {
      affiliateManagers: state => state.affiliateManagers,
      affiliateManagersLoading: s => s.affiliateManagersLoading,
      selectedAffiliateManagers: s => s.selectedAffiliateManagers,
      managerAffiliateModalOpen: s => s.managerAffiliateModalOpen
    })
  },
  methods: {
    ...mapActions('users', [
      'fetchAffiliateManagers',
      'removeManagerFromAffiliate'
    ]),
    ...mapMutations('users', [
      'updateSelectedAffiliateManagers',
      'updateManagerAffiliateModalOpen'
    ]),
    selectClass(e){
      let vm = this
      vm.one({id: e.CLASS_ID, mode: 'edit', vm})
    },
    openManagerAffiliateModal(){
      this.updateManagerAffiliateModalOpen(true)
    },
    onRemoveManager() {

      if(this.selectedAffiliateManagers.length === this.affiliateManagers.length) return notify.create({message:"Must have at least one remaining Manager association!"})

      let vm = this
        vm.$q.dialog(vm.removeDialogOptions)
        .then(() => vm.removeManagerFromAffiliate(vm))
    },
  }
}
</script>

<template>
  <div class="fit">
    <manager-affiliate-modal v-if="managerAffiliateModalOpen" />
    <Grid
      id="managerAffiliate"
      :data="affiliateManagers"
      :columns="columnOptions"
      :onRequest="fetchAffiliateManagers"
      :loading="affiliateManagersLoading"
      :selected="selectedAffiliateManagers"
      :selectable="affiliateManagers && affiliateManagers.length === 1 ? 'none' : 'multiple'"      
      :onSelect="updateSelectedAffiliateManagers"
      :hideSelectAll="true"
      hide-count
    >
      <template slot="header-left" slot-scope="props">
        <q-btn color="primary" outline icon="fa fa-user-plus" @click="openManagerAffiliateModal()">&nbsp;Add Manager</q-btn>&nbsp;
        <q-btn color="red" @click.native="onRemoveManager" v-if="selectedAffiliateManagers.length > 0">Remove</q-btn>
      </template>
      <template slot="col-item-active_ind" slot-scope="props">
        <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
          class="label"
          :class="{
              'green' : props.value === 1,
              'red' : props.value === 0
          }">
          {{props.value ? 'Active' : 'Inactive'}}
        </div>
      </template>
      <template slot="col-item-date_created" slot-scope="props">
        {{ moment(props.value).format("MMMM Do, YYYY h:mm A") }}
      </template>
    </Grid>
  </div>
</template>

<style stylus>
</style>
